/**
 * GM DTC warehouse-aware stock labels (Prestige)
 * In Stock (≥1) / Out of Stock (≤0). No Low. Never exact qty.
 * US-like ship-origin → MA qty; else NL. No cross-ship.
 *
 * Non-pointe (data-gm-block-oos-atc=1): disable ATC + Shop Pay when Out.
 * Also cap PDP/cart qty at warehouse ATP (overlay m/n). Missing map = no cap
 * (checkout ATP still blocks). Pointe always addable. Do not bulk DENY.
 *
 * 2026-09-03: guard MutationObserver — textContent writes were
 * re-entering applyAll and freezing PDPs (infinite MO loop).
 * 2026-09-15: ATC block + variant:change id update.
 * gm-atc-unavailable-20260915: OOS ATC label UNAVAILABLE.
 * gm-fierce-hide-oos-color-20260929: Fierce canary — hide non-Black
 * colors (picker + chips + Front/Back/Detail) when warehouse ATP is 0.
 * gm-cap-sleeve-hide-oos-20260929: Cap Sleeve second canary (same rules).
 * gm-sweater-tights-hide-oos-20260930: Sweater Tights Warmer canary.
 * gm-hide-gallery-filter-20260930: Prestige carousel.filter + filtered-indexes
 * (do not raw-hidden gallery cells — index shift / scrollIntoView jump).
 * gm-hide-gallery-snap-20260930: snap to featured media among VISIBLE cells;
 * hidden cells no-op scrollIntoView. Keep Prestige block:start so the still
 * top-aligns with the product title (nearest left a previous still in view).
 * gm-microtech-pants-hide-20260930: Microtech Pants Warmer canary.
 * gm-atp-qty-cap-20261020: non-pointe qty cap at warehouse ATP.
 * cdn-bust-20261020a
 */
(function () {
  'use strict';
  if (window.__gmDtcInv) return;
  window.__gmDtcInv = 1;

  var US_LIKE = {
    US: 1, PR: 1, VI: 1, GU: 1, AS: 1, MP: 1, FM: 1, MH: 1, PW: 1
  };

  var HIDE_HANDLES = {
    fierce: 1,
    'cap-sleeve': 1,
    'sweater-tights': 1,
    'madame-x': 1,
    sarabande: 1,
    moxie: 1,
    'microtech-pants': 1
  };

  var MAP_URL = null;
  var mapPromise = null;
  var mapData = null;
  var applying = false;
  var mo = null;
  var moTimer = null;
  var cartQtyByVariant = {};
  var cartPromise = null;

  var DETAIL_RE = /-(?:front|back|detail)-([a-z0-9]+)(?:-\d+)?\.(?:jpe?g|png|webp|gif)/i;
  var HERO_RE = /-hero/i;

  function scriptMapUrl() {
    var s = document.querySelector('script[data-gm-inventory-map]');
    return s && s.getAttribute('data-gm-inventory-map');
  }

  function loadMap() {
    if (mapData) return Promise.resolve(mapData);
    if (mapPromise) return mapPromise;
    MAP_URL = scriptMapUrl();
    if (!MAP_URL) return Promise.resolve(null);
    mapPromise = fetch(MAP_URL, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('map ' + r.status);
        return r.json();
      })
      .then(function (j) {
        mapData = j;
        return j;
      })
      .catch(function () {
        mapData = null;
        return null;
      });
    return mapPromise;
  }

  function countryCode() {
    var el = document.querySelector('[data-gm-inventory][data-gm-country]');
    var hideEl = document.querySelector('script[data-gm-hide-oos-colors][data-gm-country]');
    var mapEl = document.querySelector('script[data-gm-inventory-map][data-gm-country]');
    var c =
      ((el && el.getAttribute('data-gm-country')) ||
        (hideEl && hideEl.getAttribute('data-gm-country')) ||
        (mapEl && mapEl.getAttribute('data-gm-country')) ||
        document.documentElement.getAttribute('data-gm-country') ||
        (window.Shopify && window.Shopify.country) ||
        '') + '';
    c = c.toUpperCase().trim();
    if (c === 'USA') c = 'US';
    return c || 'US';
  }

  /** @returns {'m'|'n'} m = MA, n = NL */
  function warehouseKey() {
    return US_LIKE[countryCode()] ? 'm' : 'n';
  }

  function labelForQty(qty) {
    if (qty == null || isNaN(qty)) return null;
    qty = Number(qty);
    if (qty <= 0) return { status: 'error', text: 'Out of Stock' };
    return { status: 'success', text: 'In Stock' };
  }

  function qtyForVariant(variantId) {
    if (!mapData || !mapData.v) return null;
    var row = mapData.v[String(variantId)];
    if (!row) return null;
    var wh = warehouseKey();
    if (typeof row[wh] === 'number') return row[wh];
    return null;
  }

  function refreshCart() {
    if (cartPromise) return cartPromise;
    cartPromise = fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('cart ' + r.status);
        return r.json();
      })
      .then(function (j) {
        cartQtyByVariant = {};
        (j.items || []).forEach(function (it) {
          var id = String(it.variant_id);
          cartQtyByVariant[id] =
            (cartQtyByVariant[id] || 0) + Number(it.quantity || 0);
        });
        cartPromise = null;
        return cartQtyByVariant;
      })
      .catch(function () {
        cartPromise = null;
        return cartQtyByVariant;
      });
    return cartPromise;
  }

  function pdpWantQty() {
    var input = document.querySelector(
      'product-form input[name="quantity"], form[action*="/cart/add"] input[name="quantity"]'
    );
    var n = input ? parseInt(input.value, 10) : 1;
    if (!n || n < 1) n = 1;
    return n;
  }

  function remainingAtp(variantId, isCartLine) {
    var atp = qtyForVariant(variantId);
    if (atp == null || isNaN(atp)) return null;
    atp = Number(atp);
    if (isCartLine) return atp;
    var inCart = cartQtyByVariant[String(variantId)] || 0;
    return atp - inCart;
  }

  function setPlusDisabled(root, disabled) {
    var btns = root.querySelectorAll('.quantity-selector__button');
    if (!btns.length) return;
    var plus = btns[btns.length - 1];
    if (disabled) {
      plus.setAttribute('aria-disabled', 'true');
      plus.setAttribute('data-gm-atp-plus', 'off');
      plus.style.pointerEvents = 'none';
      plus.style.opacity = '0.4';
      if (plus.tagName === 'BUTTON') plus.disabled = true;
    } else {
      plus.removeAttribute('aria-disabled');
      plus.removeAttribute('data-gm-atp-plus');
      plus.style.pointerEvents = '';
      plus.style.opacity = '';
      if (plus.tagName === 'BUTTON') plus.disabled = false;
    }
  }

  function capQuantitySelectors() {
    document.querySelectorAll('quantity-selector').forEach(function (root) {
      var input = root.querySelector('input.quantity-selector__input');
      if (!input || input.getAttribute('data-gm-block-oos-atc') !== '1') return;
      var vid = input.getAttribute('data-variant-id');
      if (!vid) return;
      var isCartLine = !!input.getAttribute('data-line-key');
      var max = remainingAtp(vid, isCartLine);
      if (max == null) return;
      if (max < 0) max = 0;
      input.max = String(max);
      var val = parseInt(input.value, 10) || 0;
      if (!isCartLine && max >= 1 && val > max) input.value = String(max);
      if (!isCartLine && max < 1 && val > 1) input.value = '1';
      setPlusDisabled(root, val >= max || max < 1);
    });
  }

  function resolvedQty(el) {
    if (!el) return null;
    var qty = qtyForVariant(el.getAttribute('data-variant-id'));
    if (qty == null) {
      var fb = el.getAttribute('data-fallback-qty');
      if (fb == null || fb === '') return null;
      qty = parseInt(fb, 10);
    }
    return qty;
  }

  function applyOne(el) {
    if (!el) return;
    var qty = resolvedQty(el);
    var L = labelForQty(qty);
    if (!L) return;

    var nextClass = 'text-' + L.status;
    var wh = warehouseKey();
    var span = el.querySelector('.inventory-text');
    var curText = span ? span.textContent : el.textContent;
    var curWh = el.getAttribute('data-gm-wh') || '';
    var already =
      el.classList.contains(nextClass) &&
      (curText || '').trim() === L.text &&
      curWh === wh;
    if (already) return;

    el.classList.remove('text-success', 'text-warning', 'text-error');
    el.classList.add(nextClass);
    if (span) span.textContent = L.text;
    else el.textContent = L.text;
    el.setAttribute('data-gm-wh', wh);
  }

  function syncAtc() {
    var el = document.querySelector('[data-gm-inventory]');
    if (!el) return;
    var block = el.getAttribute('data-gm-block-oos-atc') === '1';
    var qty = resolvedQty(el);
    var oos = qty != null && !isNaN(qty) && Number(qty) <= 0;
    var over = false;
    if (block && !oos) {
      var vid = el.getAttribute('data-variant-id');
      var left = remainingAtp(vid, false);
      if (left != null && pdpWantQty() > left) over = true;
    }
    var disable = block && (oos || over);
    var btns = document.querySelectorAll(
      'product-form [type="submit"], buy-buttons [type="submit"], form[action*="/cart/add"] [type="submit"]'
    );
    btns.forEach(function (btn) {
      if (btn.closest && btn.closest('product-recommendations')) return;
      btn.disabled = !!disable;
      if (disable && oos) {
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('gm-atc-unavailable');
        var cur = (btn.textContent || '').trim();
        if (cur && cur.toUpperCase() !== 'UNAVAILABLE' && !btn.getAttribute('data-gm-atc-label')) {
          btn.setAttribute('data-gm-atc-label', cur);
        }
        if (cur.toUpperCase() !== 'UNAVAILABLE') btn.textContent = 'UNAVAILABLE';
      } else {
        btn.removeAttribute('aria-disabled');
        btn.classList.remove('gm-atc-unavailable');
        var orig = btn.getAttribute('data-gm-atc-label');
        var cur2 = (btn.textContent || '').trim().toUpperCase();
        if (orig && (cur2 === 'UNAVAILABLE' || cur2 === 'SOLD OUT')) btn.textContent = orig;
        if (disable && over) {
          btn.disabled = true;
          btn.setAttribute('aria-disabled', 'true');
        }
      }
    });
    document.querySelectorAll('.shopify-payment-button').forEach(function (n) {
      n.style.display = disable ? 'none' : '';
    });
  }

  function swatchLabel(swatch) {
    if (!swatch) return '';
    var sr = swatch.querySelector('.sr-only');
    if (sr && (sr.textContent || '').trim()) return sr.textContent.trim();
    return (swatch.textContent || '').trim();
  }

  function setHidden(el, hide) {
    if (!el) return;
    var on = !!hide;
    var was = el.getAttribute('data-gm-hide-oos-color') === '1';
    if (was === on && !!el.hidden === on) return;
    if (on) {
      el.setAttribute('data-gm-hide-oos-color', '1');
      el.hidden = true;
    } else {
      el.removeAttribute('data-gm-hide-oos-color');
      el.hidden = false;
    }
  }

  function keepSet(keep) {
    var map = {};
    (keep || ['Black']).forEach(function (k) {
      map[String(k)] = 1;
    });
    return map;
  }

  function isKeepColor(color, keep) {
    if (!color) return false;
    if (keep[color]) return true;
    return !!keep.Black && color === 'Black';
  }

  function selectKeepColor(fieldset, keep) {
    if (!fieldset) return;
    var swatches = fieldset.querySelectorAll(
      '.thumbnail-swatch, .block-swatch, .color-swatch'
    );
    for (var i = 0; i < swatches.length; i++) {
      var sw = swatches[i];
      if (sw.getAttribute('data-gm-hide-oos-color') === '1') continue;
      if (!isKeepColor(swatchLabel(sw), keep)) continue;
      var inputId = sw.getAttribute('for');
      var input = inputId ? document.getElementById(inputId) : null;
      if (input) {
        if (!input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else {
        sw.click();
      }
      return;
    }
  }

  function colorTokensFromImgs(imgs) {
    var tokens = {};
    (imgs || []).forEach(function (src) {
      var m = String(src || '').match(DETAIL_RE);
      if (m) tokens[m[1].toLowerCase()] = 1;
    });
    return tokens;
  }

  function mediaSrc(node) {
    var img = node && node.querySelector('img');
    if (!img) {
      return (
        (node &&
          (node.getAttribute('src') ||
            node.getAttribute('data-src') ||
            node.getAttribute('srcset') ||
            '')) ||
        ''
      );
    }
    return (
      img.getAttribute('src') ||
      img.getAttribute('data-src') ||
      img.currentSrc ||
      img.getAttribute('srcset') ||
      ''
    );
  }

  function restoreSizeOptions(handle) {
    var picker = document.querySelector('variant-picker[handle="' + handle + '"]');
    if (!picker) return;
    picker.querySelectorAll('.block-swatch').forEach(function (sw) {
      if (sw.getAttribute('data-gm-hide-oos-color') === '1') return;
      sw.classList.remove('is-disabled');
      sw.hidden = false;
      sw.removeAttribute('hidden');
      var inputId = sw.getAttribute('for');
      var input = inputId ? document.getElementById(inputId) : null;
      if (input && input.getAttribute('data-gm-hide-oos-color') !== '1') {
        input.disabled = false;
        input.hidden = false;
        input.removeAttribute('hidden');
      }
    });
  }

  function pdpHandle() {
    var vp = document.querySelector('variant-picker[handle]');
    return (vp && vp.getAttribute('handle')) || '';
  }

  function filterGallery(tokens, handle) {
    var pageHandle = pdpHandle();
    if (!pageHandle || handle !== pageHandle) return;
    var gallery = document.querySelector('product-gallery');
    if (!gallery) return;
    var carousel =
      gallery.carousel || gallery.querySelector('.product-gallery__carousel');
    var cells =
      carousel && carousel.allCells
        ? Array.from(carousel.allCells)
        : Array.from(gallery.querySelectorAll('.product-gallery__media'));
    var hideIdx = [];
    cells.forEach(function (cell, index) {
      var src = mediaSrc(cell);
      if (HERO_RE.test(src)) return;
      var m = src.match(DETAIL_RE);
      var tok = m ? m[1].toLowerCase() : '';
      if (tok && tokens[tok]) hideIdx.push(index);
    });
    if (!gallery.getAttribute('data-gm-filter-orig')) {
      gallery.setAttribute(
        'data-gm-filter-orig',
        gallery.getAttribute('filtered-indexes') || '[]'
      );
    }
    var orig = [];
    try {
      orig = JSON.parse(gallery.getAttribute('data-gm-filter-orig') || '[]');
    } catch (e) {
      orig = [];
    }
    var hideSet = {};
    orig.forEach(function (oneBased) {
      var i = Number(oneBased) - 1;
      if (i >= 0) hideSet[i] = 1;
    });
    hideIdx.forEach(function (i) {
      hideSet[i] = 1;
    });
    var merged = Object.keys(hideSet)
      .map(Number)
      .filter(function (i) {
        return i >= 0;
      })
      .sort(function (a, b) {
        return a - b;
      });
    if (carousel && typeof carousel.filter === 'function') {
      carousel.filter(merged);
    } else {
      cells.forEach(function (cell, index) {
        setHidden(cell, !!hideSet[index]);
      });
    }
    gallery.setAttribute(
      'filtered-indexes',
      JSON.stringify(
        merged.map(function (i) {
          return i + 1;
        })
      )
    );
    var hiddenIds = {};
    merged.forEach(function (i) {
      var cell = cells[i];
      var id = cell && cell.getAttribute('data-media-id');
      if (id) hiddenIds[id] = 1;
    });
    gallery.querySelectorAll('.product-gallery__thumbnail').forEach(function (th) {
      var id = th.getAttribute('data-media-id');
      setHidden(th, !!(id && hiddenIds[id]));
    });
    patchMediaScrollIntoView(gallery);
  }

  function digitsId(value) {
    return String(value || '').replace(/\D/g, '');
  }

  function patchMediaScrollIntoView(gallery) {
    if (!gallery) return;
    var native = Element.prototype.scrollIntoView;
    gallery.querySelectorAll('.product-gallery__media').forEach(function (cell) {
      if (cell.getAttribute('data-gm-siv') === '1') return;
      cell.setAttribute('data-gm-siv', '1');
      cell.scrollIntoView = function (opts) {
        if (this.hasAttribute('hidden')) return;
        if (opts === undefined) native.call(this);
        else native.call(this, opts);
      };
    });
  }

  function snapGalleryToVariant(variant) {
    if (!document.querySelector('script[data-gm-hide-oos-colors]')) return;
    if (!variant || !variant.featured_media) return;
    var want = digitsId(variant.featured_media.id);
    if (!want) return;
    var gallery = document.querySelector('product-gallery');
    if (!gallery) return;
    var carousel =
      gallery.carousel || gallery.querySelector('.product-gallery__carousel');
    if (!carousel) return;
    var cells = carousel.cells
      ? Array.from(carousel.cells)
      : Array.from(gallery.querySelectorAll('.product-gallery__media:not([hidden])'));
    var idx = -1;
    var cell = null;
    for (var i = 0; i < cells.length; i++) {
      if (digitsId(cells[i].getAttribute('data-media-id')) === want) {
        idx = i;
        cell = cells[i];
        break;
      }
    }
    if (!cell) return;
    if (typeof carousel.select === 'function') {
      try {
        carousel.select(idx, { instant: true });
      } catch (e) {}
    }
    var native = Element.prototype.scrollIntoView;
    native.call(cell, { block: 'start', behavior: 'smooth' });
  }

  function hideOosColors() {
    var scripts = document.querySelectorAll('script[data-gm-hide-oos-colors]');
    if (!scripts.length) return;
    if (!mapData || !mapData.v) return;

    scripts.forEach(function (script) {
      var payload;
      try {
        payload = JSON.parse(script.textContent || '');
      } catch (e) {
        return;
      }
      var handle = payload && payload.handle;
      if (!handle || !HIDE_HANDLES[handle]) return;

      var keep = keepSet(payload.keep);
      var byColor = {};
      (payload.variants || []).forEach(function (row) {
        var color = row && row.color;
        if (!color) return;
        if (!byColor[color]) byColor[color] = { imgs: [], missing: false, max: 0 };
        if (row.img) byColor[color].imgs.push(row.img);
        var qty = qtyForVariant(row.id);
        if (qty == null) byColor[color].missing = true;
        else if (Number(qty) > byColor[color].max) byColor[color].max = Number(qty);
      });

      var hidden = {};
      Object.keys(byColor).forEach(function (color) {
        if (isKeepColor(color, keep)) return;
        var info = byColor[color];
        if (!info || info.missing) return;
        if (info.max <= 0) hidden[color] = info;
      });

      var pickerSel =
        'variant-picker[handle="' +
        handle +
        '"] .thumbnail-swatch, variant-picker[handle="' +
        handle +
        '"] .block-swatch, variant-picker[handle="' +
        handle +
        '"] .color-swatch';
      document.querySelectorAll(pickerSel).forEach(function (swatch) {
        var name = swatchLabel(swatch);
        if (!byColor[name]) return;
        var hide = !!hidden[name];
        setHidden(swatch, hide);
        var inputId = swatch.getAttribute('for');
        var input = inputId ? document.getElementById(inputId) : null;
        setHidden(input, hide);
        if (hide && input && input.checked) {
          selectKeepColor(swatch.closest('fieldset'), keep);
        }
      });
      restoreSizeOptions(handle);

      var cardSel =
        'product-card[handle="' +
        handle +
        '"] .thumbnail-swatch, product-card[handle="' +
        handle +
        '"] .block-swatch, product-card[handle="' +
        handle +
        '"] .color-swatch';
      document.querySelectorAll(cardSel).forEach(function (swatch) {
        var name = swatchLabel(swatch);
        var hide = !!hidden[name];
        setHidden(swatch, hide);
        var inputId = swatch.getAttribute('for');
        if (inputId) setHidden(document.getElementById(inputId), hide);
      });

      var tokens = {};
      Object.keys(hidden).forEach(function (color) {
        var t = colorTokensFromImgs(hidden[color].imgs);
        Object.keys(t).forEach(function (k) {
          tokens[k] = 1;
        });
      });

      filterGallery(tokens, handle);
    });
  }

  function applyAll() {
    if (applying) return;
    applying = true;
    try {
      document.querySelectorAll('[data-gm-inventory]').forEach(applyOne);
      capQuantitySelectors();
      syncAtc();
      hideOosColors();
    } finally {
      applying = false;
    }
  }

  function boot() {
    loadMap()
      .then(refreshCart)
      .then(applyAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('variant:change', function (e) {
    var d = e && e.detail;
    var v = d && (d.variant || d);
    var id = v && v.id;
    if (id) {
      document.querySelectorAll('[data-gm-inventory]').forEach(function (el) {
        el.setAttribute('data-variant-id', String(id));
      });
      document.querySelectorAll('input[name="quantity"][data-gm-block-oos-atc]').forEach(function (inp) {
        if (inp.getAttribute('data-line-key')) return;
        inp.setAttribute('data-variant-id', String(id));
      });
    }
    snapGalleryToVariant(v);
    setTimeout(function () {
      loadMap().then(applyAll).then(function () {
        snapGalleryToVariant(v);
      });
    }, 50);
  });

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form) return;
      var action = (form.getAttribute && form.getAttribute('action')) || '';
      var isCart =
        (form.closest && form.closest('product-form')) ||
        action.indexOf('/cart/add') !== -1;
      if (!isCart) return;
      var el = document.querySelector('[data-gm-inventory]');
      if (!el || el.getAttribute('data-gm-block-oos-atc') !== '1') return;
      var qty = resolvedQty(el);
      if (qty != null && !isNaN(qty) && Number(qty) <= 0) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      var left = remainingAtp(el.getAttribute('data-variant-id'), false);
      if (left != null && pdpWantQty() > left) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true
  );

  document.addEventListener(
    'click',
    function (e) {
      var plus = e.target && e.target.closest && e.target.closest('.quantity-selector__button');
      if (!plus) return;
      var root = plus.closest('quantity-selector');
      if (!root) return;
      var btns = root.querySelectorAll('.quantity-selector__button');
      if (plus !== btns[btns.length - 1]) return;
      var input = root.querySelector('input.quantity-selector__input');
      if (!input || input.getAttribute('data-gm-block-oos-atc') !== '1') return;
      var max = parseInt(input.max, 10);
      var val = parseInt(input.value, 10) || 0;
      if (!isNaN(max) && val >= max) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true
  );

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.classList || !input.classList.contains('quantity-selector__input')) return;
    if (input.getAttribute('data-gm-block-oos-atc') !== '1') return;
    capQuantitySelectors();
    syncAtc();
  });

  try {
    var origFetch = window.fetch;
    if (typeof origFetch === 'function' && !origFetch.__gmAtp) {
      window.fetch = function () {
        var args = arguments;
        var url = '';
        try {
          var a0 = args[0];
          url = typeof a0 === 'string' ? a0 : (a0 && a0.url) || '';
        } catch (err) {}
        var p = origFetch.apply(this, args);
        if (/\/cart\/(add|change|update|clear)/.test(url)) {
          p.then(function () {
            refreshCart().then(applyAll);
          }).catch(function () {});
        }
        return p;
      };
      window.fetch.__gmAtp = 1;
    }
  } catch (err) {}

  try {
    mo = new MutationObserver(function () {
      if (applying) return;
      if (
        !document.querySelector('[data-gm-inventory]') &&
        !document.querySelector('script[data-gm-hide-oos-colors]') &&
        !document.querySelector('input[data-gm-block-oos-atc]')
      ) {
        return;
      }
      if (moTimer) clearTimeout(moTimer);
      moTimer = setTimeout(function () {
        moTimer = null;
        loadMap().then(applyAll);
      }, 100);
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();
